export interface AspirantDocument {
    idDocumentType: number
    idAspirantDocument: number | null
    nameDocumentType: string
    isGeneric: boolean
    isRequired: boolean
    documentUrl: string | null
    statusName: string | null
    idDocumentStatus: number | null
    idOnBase: number | null
    observation: string
}

export interface AspirantDocumentsResponse {
    documents: AspirantDocument[]
    uploadedDocuments: number
    totalFiles: number
    requiredDocuments: number
    requiredUploadedDocuments: number
}

export enum ToastType {
    FETCH_DOC = 'fetch-doc',
    LOAD_FILES = 'load-files',
    SUBMIT = 'submit',
    DELETE_DOC = 'DELETE_DOC',
    DELETE = 'delete',
    PATCH = 'patch'
}
